import React from 'react';
import CircleInfoFillIcon from '@square-icons/react/16/UI/circle-info-fill';
import RichTextContent from 'components/common/contentful/rich_text_content';
import { Box } from '@mui/material';
import { BLOCKS } from '@contentful/rich-text-types';
import { BASE_THEME } from 'theme/shop_theme';

export const PRODUCT_BANNER_ID = 'product-banner';
export const ProductBannerTypes = {
  Info: 'Info',
};

const ProductBanner = (props) => {
  const { type = null, content = null } = props;

  if (!type || !content) return null;

  let backgroundColor = null;
  let icon = null;

  switch (type) {
    case ProductBannerTypes.Info: {
      backgroundColor = '#E6F0FF';
      icon = (
        <CircleInfoFillIcon
          style={{
            paddingRight: '0.5%',
            fill: BASE_THEME.color.blue,
            verticalAlign: 'text-top',
          }}
        />
      );
      break;
    }
    default: {
      return <></>;
    }
  }

  const renderParagraph = (node, children) => {
    // Replace empty <p> nodes with <br />
    if (
      node.content.length === 1 &&
      node.content[0].nodeType === 'text' &&
      node.content[0].value === ''
    ) {
      return <br data-testid="line-break" />;
    } else {
      // render as <span> to support icon component
      return (
        <span
          style={{
            lineHeight: '1.5',
          }}
        >
          {children}
        </span>
      );
    }
  };

  const renderDocument = (node, children) => {
    return (
      <>
        {icon}
        {children}
      </>
    );
  };

  return (
    <>
      <Box
        data-testid={PRODUCT_BANNER_ID}
        sx={{
          backgroundColor,
          paddingLeft: '15%',
          paddingRight: '15%',
          py: 2,
          textAlign: 'center',
        }}
      >
        <RichTextContent
          content={content.message}
          rendererOptions={{
            renderNode: {
              [BLOCKS.PARAGRAPH]: renderParagraph,
              [BLOCKS.DOCUMENT]: renderDocument,
            },
          }}
        />
      </Box>
    </>
  );
};

export default ProductBanner;
